import { useEffect, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import i18n, {
  setDocumentDir,
  detectClientLanguage,
  changeLanguage as changeAppLanguage,
  LANG_STORAGE_KEY,
  type AppLang,
} from "./index";

export function LanguageProvider({ children }: { children: ReactNode }) {
  const { i18n: instance } = useTranslation();

  useEffect(() => {
    // Apply preferred language AFTER hydration to keep SSR/first render deterministic.
    const preferred = detectClientLanguage();
    if (preferred !== instance.language) {
      void changeAppLanguage(preferred);
    } else {
      setDocumentDir(instance.language || "en");
    }
    const handler = (lng: string) => {
      setDocumentDir(lng);
      try {
        window.localStorage.setItem(LANG_STORAGE_KEY, lng);
      } catch {
        /* noop */
      }
    };
    instance.on("languageChanged", handler);
    return () => {
      instance.off("languageChanged", handler);
    };
  }, [instance]);

  return <>{children}</>;
}

export function setLanguage(lang: AppLang) {
  void changeAppLanguage(lang);
}
